import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import logo from "../../../assets/images/front/user01.webp";
import Button from "../../form/Button";
import { useNavigate } from "react-router-dom";

const JobCarousel = ({ jobs = [], companyImage, slug }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const navigate = useNavigate();
  // Called once Swiper is mounted — re-init navigation now that refs are live
  const handleSwiperInit = (swiper) => {
    setSwiperInstance(swiper);
    swiper.params.navigation.prevEl = prevRef.current;
    swiper.params.navigation.nextEl = nextRef.current;
    swiper.navigation.destroy();
    swiper.navigation.init();
    swiper.navigation.update();
  };
  const handleJobClick = (jobSlug) => {
    if (!jobSlug) return;
    navigate(`/job/${jobSlug}`);
  };
  return (
    <div>
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4">
        <h3 className="text-base font-semibold text-gray-800">
          Recently posted jobs
        </h3>

        <div className="flex justify-between md:justify-normal gap-2">
          <button
            ref={prevRef}
            className="px-3 py-1 text-sm font-medium rounded  text-gray-600 hover:text-gray-800 cursor-pointer select-none disabled:opacity-40"
          >
            <i class="fa-solid fa-angle-left mr-1"></i> Prev
          </button>
          <button
            ref={nextRef}
            className="px-3 py-1 text-sm font-medium rounded  text-gray-600 hover:text-gray-800 cursor-pointer select-none disabled:opacity-40"
          >
            Next <i class="fa-solid fa-angle-right ml-1"></i>
          </button>
        </div>
      </div>

      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={10}
        slidesPerView={1}
        loop={true}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        pagination={{
          clickable: true,
        }}
        onSwiper={handleSwiperInit}
        breakpoints={{
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 2 },
        }}
        className="pb-10 jobs-swiper"
      >
        {/* {jobData.map((job, index) => (
          <SwiperSlide key={index}>
            <div className="items-center border p-4 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 relative h-full">
              <img
                src={job.logo}
                alt={job.company}
                className="w-14 h-14 rounded-md mr-4 mb-2"
              />
              <div className="font-sans">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">{job.title}</h4>
                <p className="text-gray-600 text-sm">{job.company}</p>
                <p className="text-sm text-gray-500 mb-1">{job.location}</p>
                <p className="text-[13px] text-palatte2 font-normal">{job.posted}</p>
              </div>
            </div>
          </SwiperSlide>
        ))} */}

        {jobs.map((job) => {
          const title = job?.content?.en?.title;
          const excerpt = job?.content?.en?.content;
          const jobSlug = job?.slug;

          return (
            <SwiperSlide key={job._id}>
              <div
                onClick={() => handleJobClick(jobSlug)}
                className="border p-4 rounded-lg shadow hover:shadow-lg transition-shadow duration-300 h-full cursor-pointer"
              >
                {companyImage ? (
                  <img
                    src={companyImage}
                    alt="company"
                    className="w-14 h-12 rounded object-contain border"
                  />
                ) : (
                  <div className="w-14 h-14 bg-gray-200 rounded flex items-center justify-center text-sm font-semibold text-gray-500">
                    {title?.charAt(0)}
                  </div>
                )}
                <div className="font-sans">
                  <h4 className="text-sm font-semibold text-gray-900 mb-2">
                    {title}
                  </h4>

                  {excerpt && (
                    <div
                      className="text-gray-600 text-sm line-clamp-3 mb-2"
                      dangerouslySetInnerHTML={{ __html: excerpt }}
                    />
                  )}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      <div className="text-center mt-2 pt-3 border-t border-gray-200 text-sm">
        <Button
          buttonLabel="Show All Jobs"
          buttonHasLink
          buttonLink={`/job?organization=${slug}`}
          buttonIcon={"fa-regular fa-arrow-right"}
          buttonIconPosition="right"
          buttonClasses="bg-white hover:bg-transparent h-9 rounded-full hover:bg-transparent text-gray-500 hover:text-gray-700 font-medium "
          buttonLabelClasses="font-semibold"
        />
      </div>
    </div>
  );
};

export default JobCarousel;
